<script lang="ts">
	import { getContext } from "svelte";
	import { writable, type Writable } from "svelte/store";
	import type { Checkout, PaymentInfo } from "#gen/products/v1/product_pb.js";
	import CheckoutSummary from "#lib/components/flow/editor/content/commerce/CheckoutSummary.svelte";
	import type { ComponentProps } from "#lib/components/page/ComponentProps.js";

	type Props = ComponentProps;

	const pageState: Writable<{ checkout?: Writable<Checkout>; paymentInfo?: Writable<PaymentInfo> }> = getContext("pageState");

	let { id }: Props = $props();

	const checkout: Writable<Checkout> = $pageState.checkout || writable<Checkout>();
	const paymentInfo: Writable<PaymentInfo> = $pageState.paymentInfo || writable<PaymentInfo>();

	$pageState.checkout = checkout;
	$pageState.paymentInfo = paymentInfo;
</script>

<CheckoutSummary {id} {checkout} {paymentInfo} />
